// extracted by mini-css-extract-plugin
export default {"root":"SchemaList_root__dJOk1","keyword":"SchemaList_keyword__6k+5f","keywordIcon":"SchemaList_keywordIcon__YN0RX"};